module.exports = __webpack_public_path__ + "static/media/sound.e22b1eec.wav";


//////////////////
// WEBPACK FOOTER
// ./src/Media/sound.wav
// module id = 41
// module chunks = 0